import React, { useEffect, useState } from 'react';
import Layout from "../layout/Layout";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import CustomPagination from "../components/CustomPagination";
import CustomFormInput from "../components/CustomFormInput";
import DeleteModal from '../components/DeleteModal';
import SendNotificationModal from '../components/NotificationManagement/SendNotificationModal';
import { deleteBroadcastNotification, getNotificationList } from '../controller';
import { requestHandler } from '../helper';
import Loader from '../components/Loader';
import { formatDate } from '../helper/common';
import { toast } from 'react-toastify';
import NotificationViewModal from '../components/NotificationManagement/NotificationViewModal';

function NotificationManagement() {

  const [show, setShow] = useState(false);
  const [showNotification, setNotificationShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const [viewShow, setViewShow] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState({});

  const handleClose = () => {
    setShow(false);
    setSelectedBroadCast(null);
  }
  const handleShow = (notification) => {
    setSelectedBroadCast(notification);
    setShow(true);
  }

  const [selectedBroadcast, setSelectedBroadCast] = useState(null);

  const handleNotificationShow = () => setNotificationShow(true);

  const [notificationData, setNotificationData] = useState();
  const [paginationValue, setPaginationValue] = useState({
    page: 1,
    limit: 10,
    totalData: 0,
    totalPages: 0
  })
  const { page, limit, totalData, totalPages } = paginationValue
  const [search, setSearch] = useState("");
  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, totalData);

  const getNotificationData = async (page = 1) => {
    await requestHandler(
      async () => await getNotificationList(limit, page, search),
      setLoading,
      (res) => {
        const { data, limit, page, totalData, totalPages } = res.data;
        setNotificationData(data);
        setPaginationValue({
          page,
          limit,
          totalData,
          totalPages
        })
      },
      () => { }
    );
  };

  useEffect(() => {
    if (search) {
      const delayDebounce = setTimeout(() => {
        getNotificationData(1, search);
      }, 500);
      return () => clearTimeout(delayDebounce);
    } else {
      getNotificationData(1)
    }
    // eslint-disable-next-line
  }, [paginationValue.limit, search])


  const methodObj = {
    email: "Email only",
    inApp: "In-App Notification",
    both: "Both"
  }

  const typeObj = {
    all: "All User",
    student: "Student",
    teacher: "Teacher",
    teacherVerified: "Teacher(Verified)",
    selectedUser: "Selected Users",
  }


  const handleEditShow = (notification) => {
    setSelectedBroadCast(notification);
    setNotificationShow(true);
  };

  const deleteNotificationList = async (id) => {
    await requestHandler(
      async () => await deleteBroadcastNotification(id),
      setLoading,
      (res) => {
        toast.success(res.message);
        getNotificationData(1);
        setShow(false);
        setSelectedBroadCast(null);
      },
      () => { }
    );
  };


  const handleViewShow = (user) => {
    setSelectedNotification(user);
    setViewShow(true);
  }
  const handleViewClose = () => {
    setSelectedNotification(null);
    setViewShow(false);
  }


  return (
    <>
      {loading && <Loader />}
      <Layout>
        <div className="card-wrapper">
          <div className="card-header">
            <div className='theme-select'>
              <Form.Select required name="limit" onChange={e => setPaginationValue({ ...paginationValue, [e.target.name]: e.target.value })}>
                <option >10</option>
                <option >15</option>
                <option >20</option>
              </Form.Select>
            </div>
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <div className="search-input">
                <img src="/images/svg/search.svg" className="search-icon" alt="icon" />
                <CustomFormInput
                  type="search"
                  placeholder="Search here..."
                  id="search"
                  className="mb-0"
                  value={search}
                  name='search'
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
              <button className='btn btn-outline-primary fs-16 fw-600' onClick={handleNotificationShow}>Send Notification</button>
            </div>
          </div>
          <div className="card-body">
            <div className='overflow-x-auto theme-scrollbar'>
              <Table className="theme-table">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Type</th>
                    <th>Method</th>
                    <th>Title</th>
                    <th>Scheduled Time</th>
                    <th>Send</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Boolean(notificationData?.length) ? notificationData.map((item, index) => (
                    <tr key={index}>
                      <td>{(10 * (page - 1)) + (index + 1)}</td>
                      <td>
                        {typeObj[item?.type]}
                      </td>
                      <td>{methodObj[item?.method]}</td>
                      <td width={200}>{item?.title}</td>
                      <td>
                        {item?.scheduleTime ? formatDate(item?.scheduleTime) : '-'}
                      </td>
                      <td >
                        {item?.isSend === 1 ?
                          <>Yes</>
                          :
                          <>No</>
                        }
                      </td>
                      <td width={90}>
                        <div className="d-flex align-items-center gap-2">
                          <button className="table-icon" onClick={() => handleViewShow(item)}>
                            <img src="/images/svg/table-view.svg" alt="icon" />
                          </button>
                          <button className="table-icon border-danger-light" onClick={() => handleShow(item)}>
                            <img src="/images/svg/table-delete.svg" alt="icon" />
                          </button>
                          <button
                            disabled={Boolean(item?.isSend)}
                            onClick={() => handleEditShow(item)} className="table-icon border-primary-light">
                            <img src="/images/svg/table-edit.svg" alt="icon" />
                          </button>
                          {/* <Link to="/event-management/edit" className="table-icon border-primary-light">
                            <img src="/images/svg/table-edit.svg" alt="icon" />
                          </Link> */}
                        </div>
                      </td>
                    </tr>
                  )) :
                    <tr>
                      <td colSpan={10} className='text-center p-5 fs-5'>
                        No Records Found
                      </td>
                    </tr>}
                </tbody>
              </Table>
            </div>
            <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap mt-1 ">
              <p className="mb-0 fs-16 fw-500 text-light">
                Showing {start} to {end} of {totalData} entries</p>
              {totalPages > 1 && (
                <CustomPagination
                  currentPage={page}
                  totalPages={totalPages}
                  onPageChange={getNotificationData}
                />
              )}
            </div>
          </div>
        </div>
      </Layout>
      <NotificationViewModal show={viewShow} handleClose={handleViewClose} selectedNotification={selectedNotification} />
      <DeleteModal show={show} handleClose={handleClose} title="Delete Notification" message="Are you sure you want to delete this notification?" handleDelete={() => deleteNotificationList(selectedBroadcast?._id)} />
      <SendNotificationModal show={showNotification} setSelectedBroadCast={setSelectedBroadCast} setNotificationShow={setNotificationShow} selectedBroadcast={selectedBroadcast} getNotificationData={getNotificationData} />
    </>
  )
}

export default NotificationManagement